var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 24,
    rx: 23.5,
    ry: 24,
    fill: "#EBEDF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42407 25.8021C7.42407 25.8021 10.6953 20.0474 15.4807 27.0135C16.6006 28.6439 17.4191 32.8895 20.5692 33.0713C20.5692 33.0713 16.2214 36.1252 13.4215 30.6481C12.5439 28.9316 11.2404 25.2568 7.42407 25.8021Z",
    fill: "#353EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.603 20.8951C13.603 20.8951 17.1927 18.8826 20.5692 27.3165C21.6021 29.8961 24.7493 36.4029 30.0798 33.0711C30.0798 33.0711 27.3179 32.5412 23.7195 24.7116C22.5907 22.2559 17.7827 15.2616 13.603 20.8951Z",
    fill: "#353EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.176 15.9284C19.176 15.9284 22.6895 14.0508 26.8694 22.4707C26.8694 22.4707 34.926 38.9478 38.8636 30.7698C38.8636 30.7698 35.2898 30.7698 31.4127 22.8946C29.8581 19.7365 25.7792 9.87082 19.176 15.9284Z",
    fill: "#353EE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6262 14.4136C28.6262 14.4136 32.988 15.7466 32.8666 21.2588C32.8666 21.2588 34.1995 20.7741 35.7135 21.5616C35.7135 21.5616 35.7141 14.8979 28.6262 14.4136Z",
    fill: "#353EE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.271 28.2566C37.8255 29.7058 38.8738 29.7984 38.892 29.7995L38.8987 29.7999C39.1837 28.9995 40.9759 23.2246 33.7751 22.1069C33.7751 22.1069 37.9273 24.9378 36.271 28.2566Z",
    fill: "#353EE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.756 33.4958C10.756 33.4958 7.72714 30.1642 9.48379 26.6508C9.48379 26.6508 7.00006 26.1056 7.00006 27.8623C7.00006 27.8623 6.93965 31.8603 10.756 33.4958Z",
    fill: "#353EE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4204 25.2573C15.4204 25.2573 15.2468 22.4985 16.147 22.1072C16.147 22.1072 13.603 20.714 12.9365 23.1978C12.9365 23.1978 14.209 23.7433 15.4204 25.2573Z",
    fill: "#353EE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8723 19.4422C20.8723 19.4422 21.1146 18.1094 22.2656 17.3219C22.2656 17.3219 19.2974 15.4436 17.7828 17.988C17.7828 17.988 19.903 18.2914 20.8723 19.4422Z",
    fill: "#353EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnm);
export default __webpack_public_path__ + "static/media/anm.0f1cba1d728b79f65bd0d19b2d9be30c.svg";
export { ForwardRef as ReactComponent };